<template>
  <v-row
    v-if="teacher"
    align=center
    justify=center
    justify-md=space-between
    justify-sm=space-between
    >
    <v-col
      cols=auto
      >
      <v-container
        fluid
        class="no--vertical--paddings">
        <v-row
          justify=start
          align=center
          style="cursor:pointer"
          @click="$emit('info-button-click', teacher)">
          <v-col
            cols=auto
            class="no--vertical--paddings">
            <v-avatar>
              <img
                :src="teacher.iconUrl"
                alt=""
                >
            </v-avatar>
          </v-col>
          <v-col
            cols=auto
            class="no--vertical--paddings">
            <h4>{{teacher.fullName()}}</h4>
            <span>{{teacher.universityInfo()}}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
    <v-col
      cols=auto>
      <v-container
        fluid
        class="no--vertical--paddings">
        <v-row
        justify=center
          >
          <v-col
            cols=auto>
            <v-tooltip
              top>
              <template
                v-slot:activator="{ on }"
                >
                <v-btn
                  fab
                  icon
                  v-on="on"
                  @click="$emit('accept-button-click', teacher)"
                  >
                  <v-icon dark>
                    fa-check
                  </v-icon>
                </v-btn>
              </template>
              <span>承認</span>
            </v-tooltip>
            <v-tooltip
              top>
              <template
                v-slot:activator="{ on }"
                >
                <v-btn
                  fab
                  icon
                  v-on="on"
                  @click="$emit('deny-button-click', teacher)"
                  >
                  <v-icon dark>
                    fa-times
                  </v-icon>
                </v-btn>
              </template>
              <span>拒否</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import { firestore } from "@/repository/client/firestore"
import { TeacherRepository } from "@/repository/TeacherRepository"
export default {
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      teacher: null
    }
  },
  methods: {

  },
  async created () {
    const teacherRepo = new TeacherRepository(firestore)
    this.teacher = await teacherRepo.find(this.request.senderId)
  }
}
</script>

<style scoped>
.no--vertical--paddings {
  padding: 0px 12px;
}
</style>
